import app from 'flarum/common/app';
app.initializers.add('hli-oauth-slp-provider-common', () => {
  console.log('[hli/flarum-ext-oauth-slp-provider] Hello, forum and admin!');
});